import { estimateLink } from "@constants";
import { HeaderType } from "@models";

export const estimate_header: HeaderType = {
  name: "Get Estimate",
  title: "<b>Shocked</b> by your<br/> energy bills?",
  subTitle: "",
  content:
    "Replacing your old, inefficient boiler with a high efficient condensing boiler and smart thermostat can save you up to <b>€510 a year*</b> on your energy bills.",
  src: "/assets/images/estimate/estimate_header.webp",
  financeText: "",
  buttonText: "",
  maxWidth: 550,
  notFullImage: true,
  plImage: true,
};

export const estimate_data = [
  {
    title: "Solar PV",
    src: "/assets/images/estimate/solar.webp",
    link: estimateLink.services.solar,
    content: "Solar PV is offered by Bord Gáis Energy",
  },
  {
    title: "Boilers",
    src: "/assets/images/estimate/boiler.webp",
    link: estimateLink.services.boiler,
    content: "",
  },
];
